<template>
	<form-field-wrap
			:field-props="fieldProps"
			:is-error="isError"
			:field-value="fieldValue"
			:is-switch="isSwitch"
			:input-focus="inputFocus"
			:with-label="withLabel"
	>
		<template>
			<input class="hidden"
             type="hidden"
			       autocomplete="off"
			       v-validate="rules"
			       :data-vv-as="fieldProps.TITLE"
			       :name="fieldProps.CODE"
			       :value="fieldValue"
			       :id="fieldProps.ID ? fieldProps.ID : fieldProps.CODE"
			>
      <p class="form-nps__descr" v-html="fieldProps.DESCRIPTION"></p>
      <span class="nps__rate js-rating" v-html="fieldValue ? fieldValue : 0"></span>
      <div class="star-rating js-star-rating">
        <template v-for="i in rating">
          <input type="radio" :data-id="i.id" :id="i.id" name="rating" :value="i.key" @change="changeValue(i.key)">
          <label class="icon icon--star-filled" :for="i.id" :title="i.rating_value"></label>
        </template>
      </div>
		</template>
	</form-field-wrap>
</template>

<script>
	export default {
		name: "FormFieldRating",
		data() {
			return {
				inputFocus: false,
				inputValue: "",
				error: false,
				withLabel: false
			}
		},
    computed: {
      /**
       * Формирование массива для радиокнопок рейтинга
       */
      rating() {
        let arRating = {};
        let index = 0;

        for (let i = this.fieldProps.MAX_RATING; i >= 1; i--)
        {
          arRating[index++] = {
            'key': i,
            'id': 'f-star-' + i,
            'rating_value': "Оценка «" + i + "»"
          };
        }

        return arRating;
      },
    },
		methods: {
			changeValue: function (value) {
				this.$emit('input', value);
				setTimeout(() => {
					this.$validator.validate();
				}, 10);
			}
		},
	}
</script>
